import { authRoles } from 'app/auth';
import { FuseLoadable } from '@fuse';

const ProcessedFluidReceiving = {
    auth: [...authRoles.admin, ...authRoles.hauling, ...authRoles.processor],
    routes: [{ path: '/processed-fluid/receiving', component: FuseLoadable({ loader: () => import('./ProcessedFluidReceivingApp') }) }],
};

export default ProcessedFluidReceiving;
